import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "dropzone", "preview", "progress"]
    static values  = { maxMb: Number, autoSubmit: Boolean }

    connect() {
        this._onDragOver = (e) => { e.preventDefault(); this.element.classList.add("border-tealLight"); }
        this._onDragLeave = () => this.element.classList.remove("border-tealLight")
        this._onDrop = (e) => {
            e.preventDefault()
            this.element.classList.remove("border-tealLight")
            if (!this.hasInputTarget) return
            const files = e.dataTransfer?.files
            if (files && files.length) {
                this.inputTarget.files = files
                this._afterChoose()
            }
        }
        this._onClick = () => this.inputTarget?.click()
        this._onChange = () => this._afterChoose()

        this.dropzoneTarget?.addEventListener("dragover", this._onDragOver)
        this.dropzoneTarget?.addEventListener("dragleave", this._onDragLeave)
        this.dropzoneTarget?.addEventListener("drop", this._onDrop)
        this.dropzoneTarget?.addEventListener("click", this._onClick)
        this.inputTarget?.addEventListener("change", this._onChange)
    }

    disconnect() {
        this.dropzoneTarget?.removeEventListener("dragover", this._onDragOver)
        this.dropzoneTarget?.removeEventListener("dragleave", this._onDragLeave)
        this.dropzoneTarget?.removeEventListener("drop", this._onDrop)
        this.dropzoneTarget?.removeEventListener("click", this._onClick)
        this.inputTarget?.removeEventListener("change", this._onChange)
    }

    _afterChoose() {
        if (!this.hasInputTarget) return
        const files = Array.from(this.inputTarget.files || [])
        if (!files.length) return

        // Size guard
        const tooBig = this.maxMbValue
            ? files.find(f => f.size > this.maxMbValue * 1024 * 1024)
            : null

        if (tooBig) {
            alert(`File "${tooBig.name}" exceeds ${this.maxMbValue} MB.`)
            this.inputTarget.value = ""
            this._hidePreview()
            return
        }

        // Show preview
        const label = files.length === 1
            ? `${files[0].name} · ${(files[0].size/1024/1024).toFixed(2)} MB`
            : `${files.length} files selected`
        if (this.hasPreviewTarget) {
            this.previewTarget.textContent = label
            this.previewTarget.classList.remove("hidden")
        }

        if (this.autoSubmitValue) {
            const form = this.element.closest("form")
            form?.requestSubmit?.()
        }
    }

    _hidePreview() {
        if (this.hasPreviewTarget) {
            this.previewTarget.textContent = ""
            this.previewTarget.classList.add("hidden")
        }
    }
}
